import clearFeature from './clear-feature.action';

export default clearFeature;
